import { useEffect, useState } from "react";
import api from "../api";

export default function LogsAdminDashboard() {

  const [logs, setLogs] =
    useState([]);

  const [filteredLogs, setFilteredLogs] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  // =====================
  // FILTRES
  // =====================

  const [search, setSearch] =
    useState("");

  const [statut, setStatut] =
    useState("");

  const [userId, setUserId] =
    useState("");

  const [date, setDate] =
    useState("");

  // =====================
  // FETCH
  // =====================

  useEffect(() => {
    fetchLogs();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [
    logs,
    search,
    statut,
    userId,
    date
  ]);

  const fetchLogs = async () => {

    try {

      const res =
        await api.get("/logs");

      setLogs(res.data);

    } catch (err) {

      console.error(err);

      if (
        err.response?.status === 401
      ) {

        localStorage.clear();

        window.location.href = "/";

      }

    } finally {

      setLoading(false);

    }
  };

  // =====================
  // FILTERS
  // =====================

  const applyFilters = () => {

    let data = [...logs];

    // RECHERCHE
    if (search) {

      data = data.filter(
        (log) =>
          `${log.action}
          ${log.details}
          ${log.ip_address}`
            .toLowerCase()
            .includes(
              search.toLowerCase()
            )
      );

    }

    // STATUT
    if (statut) {

      data = data.filter(
        (log) =>
          log.statut === statut
      );

    }

    // USER
    if (userId) {

      data = data.filter(
        (log) =>
          String(log.user_id) ===
          userId
      );

    }

    // DATE
    if (date) {

      data = data.filter(
        (log) =>
          new Date(
            log.created_at
          )
            .toISOString()
            .slice(0, 10) === date
      );

    }

    setFilteredLogs(data);
  };

  // =====================
  // LOADING
  // =====================

  if (loading) {

    return (
      <p className="p-4 md:p-6">
        Chargement...
      </p>
    );

  }

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 bg-gray-100 min-h-[100dvh]">

      <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow p-3 md:p-6">

        {/* HEADER */}
        <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
          Logs système
        </h1>

        {/* FILTRES */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 mb-5">

          {/* SEARCH */}
          <input
            placeholder="Recherche (action, IP...)"
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
            className="border p-3 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-400"
          />

          {/* STATUT */}
          <select
            value={statut}
            onChange={(e) =>
              setStatut(
                e.target.value
              )
            }
            className="border p-3 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-400"
          >

            <option value="">
              Tous statuts
            </option>

            <option value="SUCCESS">
              SUCCESS
            </option>

            <option value="FAILED">
              FAILED
            </option>

            <option value="VALIDE">
              VALIDE
            </option>

            <option value="INVALIDE">
              INVALIDE
            </option>

          </select>

          {/* USER */}
          <input
            placeholder="User ID"
            value={userId}
            onChange={(e) =>
              setUserId(
                e.target.value
              )
            }
            className="border p-3 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-400"
          />

          {/* DATE */}
          <input
            type="date"
            value={date}
            onChange={(e) =>
              setDate(
                e.target.value
              )
            }
            className="border p-3 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-400"
          />

        </div>

        {/* TABLE */}
        <div className="overflow-x-auto max-h-[70dvh] overflow-y-auto rounded-xl border">

          <table className="min-w-[950px] w-full border-collapse text-sm">

            <thead className="sticky top-0 bg-gray-200 text-left z-10">

              <tr>

                <th className="p-3 whitespace-nowrap">
                  User
                </th>

                <th className="p-3 whitespace-nowrap">
                  Action
                </th>

                <th className="p-3 whitespace-nowrap">
                  Détails
                </th>

                <th className="p-3 whitespace-nowrap">
                  Facture
                </th>

                <th className="p-3 whitespace-nowrap">
                  IP
                </th>

                <th className="p-3 whitespace-nowrap">
                  Statut
                </th>

                <th className="p-3 whitespace-nowrap">
                  Date
                </th>

              </tr>

            </thead>

            <tbody>

              {filteredLogs.map(
                (log) => (

                  <tr
                    key={log.id}
                    className="border-b hover:bg-gray-50 transition"
                  >

                    {/* USER */}
                    <td className="p-3 whitespace-nowrap">
                      {log.user_id ||
                        "-"}
                    </td>

                    {/* ACTION */}
                    <td className="p-3 font-medium whitespace-nowrap">
                      {log.action}
                    </td>

                    {/* DETAILS */}
                    <td className="p-3 text-gray-600 break-words max-w-[280px]">
                      {log.details ||
                        "-"}
                    </td>

                    {/* FACTURE */}
                    <td className="p-3 whitespace-nowrap">
                      {log.facture_id
                        ? `#${log.facture_id}`
                        : "-"}
                    </td>

                    {/* IP */}
                    <td className="p-3 whitespace-nowrap">
                      {log.ip_address}
                    </td>

                    {/* STATUS */}
                    <td className="p-3 whitespace-nowrap">

                      <span
                        className={`px-2 py-1 rounded text-white text-xs ${
                          [
                            "SUCCESS",
                            "VALIDE"
                          ].includes(
                            log.statut
                          )
                            ? "bg-green-500"
                            : [
                                "FAILED",
                                "INVALIDE"
                              ].includes(
                                log.statut
                              )
                            ? "bg-red-500"
                            : "bg-gray-500"
                        }`}
                      >
                        {log.statut}
                      </span>

                    </td>

                    {/* DATE */}
                    <td className="p-3 whitespace-nowrap">
                      {new Date(
                        log.created_at
                      ).toLocaleString()}
                    </td>

                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

        {/* EMPTY */}
        {!loading &&
          filteredLogs.length ===
            0 && (
            <div className="text-center text-gray-400 text-sm py-6">
              Aucun log trouvé
            </div>
          )}

      </div>

    </div>
  );
}